import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalFooterDirective } from 'mbs-ui-kit';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { HelpLinkDirective } from 'mbs-ui-shared@help/helpLink.directive';
import { OsType } from 'mbs-ui-shared@models/Computer';

@UntilDestroy()
@Component({
  selector: 'backup-agent-update-required-modal',
  templateUrl: './backup-agent-update-required-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    HelpLinkDirective,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class BackupAgentUpdateRequiredModalComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public get version() {
    const requiredVersions = {
      [OsType.windows]: '7.7',
      [OsType.apple]: '4.4'
    };

    return requiredVersions[this.baseModal.data.os];
  }

  public computerName: string;
  public alertType = MbsPopupType.warning;

  ngAfterViewInit(): void {
    if (this.baseModal.data) {
      this.computerName = this.baseModal.data.computerName;
      this.cdr.detectChanges();
    }
  }
}
